Vue.component("disclaimer_modal", {
  data() {
    return {
      dialogVisible: false,
      title: '',
      content: '',
      list: [],
      index: 0,
      timeOut: 0,
      loading: false
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    startTimeOut() {
      const that = this
      that.timeOut = 30
      let timer = setInterval(() => {
        that.timeOut--
        if (that.timeOut <= 0) {
          clearInterval(timer)
          timer = null
        }
      }, 1000)
    },
    getInfo() {
      const that = this
      API.reqDisclaimerInfo().then(res => {
        if (res.errorCode == 'success' && res.extendMessage && res.extendMessage.length) {
          that.title = res.extendMessage[0].title
          that.list = res.extendMessage
          that.getCurrent()
          that.dialogVisible = true
        }
      })
    },
    getCurrent() {
      this.content = this.list[this.index].content.replaceAll('\r\n', '<br>')
      this.startTimeOut()
      this.$nextTick(() => {
        this.$refs.disclaimer_content.scrollTop = 0
      })
    },
    handleConfirm() {
      if (this.timeOut > 0) {
        this.$message.info('请耐心阅读')
        return
      }
      if (this.index < this.list.length - 1) {
        this.index++
        this.getCurrent()
      } else {
        this.dialogVisible = false
        this.loading = true
        API.reqConfirmDisclaimer()
      }
    },
    handleScroll(e) {
      //防止滚动内容触发到首页页面滚动
      e.stopPropagation()
      return false
    }
  },
  template: `
    <el-dialog custom-class="disclaimer_modal" :title="title" :visible.sync="dialogVisible" width="80%" center :show-close="false" :close-on-click-modal="false">
      <div class="disclaimer_content" v-html="content" ref="disclaimer_content" @wheel="handleScroll"></div>
      <div v-loading="loading" class="read_btn" @click="handleConfirm">{{(index == list.length - 1)? '我已阅读': '阅读下一个'}} {{timeOut > 0? ('(' + timeOut + 's)'): ''}}</div>
    <el-dialog>
  `,
});